import { Vue, Component, Prop } from 'vue-property-decorator'
import { format } from 'fecha'
import BasketNumber from '~/components/element/BasketNumber'
import BasketSvg from '~/assets/svg/product-basket.svg?inline'
import ErrorSvg from '~/assets/svg/product-error.svg?inline'
import DiscountSvg from '~/assets/svg/discount.svg?inline'
import HotSvg from '~/assets/svg/hot.svg?inline'
import NewSvg from '~/assets/svg/new.svg?inline'
import ProductDaySvg from '~/assets/svg/product-day.svg?inline'
import ImageElement from '~/components/element/ImageElement'
import HeartSvg from '~/assets/svg/heart.svg?inline'
import RatingStars from '~/components/element/RatingStars'
import s from '~/utils/s'
import SwitchElement from '~/components/element/SwitchElement'
import { SlideOptions } from '~/types/Slider'
import loc from '~/utils/loc'
import UserLists from '~/components/page/userProductList/UserLists'
import List from '~/assets/svg/list.svg?inline'
import ProductSlidesAnalogs from '~/components/block/ProductSlidesAnalogs'

@Component
export default class ProductInfo extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isAnalogs?: boolean

  expirationDate: string | undefined = s(this.$store).productPage.expirationDate
  expirationTooltip: string | undefined = s(this.$store).productPage.expirationTooltip

  sliderOptions: SlideOptions = {
    slidesToShow: 1,
    infinite: true,
    navButtons: false,
    dots: false
  }

  renderUserLists: boolean = false

  get inUList (): boolean {
    return s(this.$store).userProductList.ids.includes(s(this.$store).productPage.id)
  }

  get isBasket (): boolean {
    return s(this.$store).basket.items.find(e => e.product.id === s(this.$store).productPage.id) !== undefined
  }

  get isWaitingList (): boolean {
    return s(this.$store).waitingList.items.map(id => id.product.id).includes(s(this.$store).productPage.id)
  }

  get isWaitingListModifier (): any {
    if (this.isWaitingList) {
      return ['waiting_selected']
    }
    return []
  }

  get isMnn (): boolean {
    return s(this.$store).productPage.mnn.length > 0
  }

  get isDiscount (): boolean {
    return s(this.$store).productPage.price < s(this.$store).productPage.basePrice
  }

  get isFavorite (): boolean {
    return s(this.$store).wishlist.ids.includes(s(this.$store).productPage.id)
  }

  get isAvailable (): boolean {
    return s(this.$store).productPage.available > 0
  }

  renderAnalogs () {
    if (this.isAnalogs) {
      return (
        <div class="product-info__col-analogs">
          <div class="product-info__analogs-products-container">
            <div class="product-info__analogs-products-items">
              <ProductSlidesAnalogs {...{
                props: {
                  products: s(this.$store).productPage.analogs,
                  title: 'Другие формы выпуска',
                  isShowButton: false
                }
              }} />
            </div>
          </div>
        </div>
      )
    }
  }

  async addToBasket () {
    await s(this.$store).basket.add(s(this.$store).productPage.id)
    if (this.isWaitingList) {
      this.addToWaitingList(false)
    }
  }

  async addToWaitingList (value: boolean) {
    if (value && !this.isWaitingList) {
      await s(this.$store).waitingList.addProductToWaitingList(s(this.$store).productPage.id)
    } else if (!value && this.isWaitingList) {
      await s(this.$store).waitingList.removeProductFromWaitingList(s(this.$store).productPage.id)
    }
  }

  renderBasketButton () {
    if (this.isBasket) {
      return (
        <nuxt-link to={loc(this.$store, { name: 'basket' })} class="product-page-info__bakset-button-in">
          <div class="product-page-info__bakset-button-logo">
            <BasketSvg/>
          </div>
          <div class="product-page-info__bakset-button-text">
            В корзине
          </div>
        </nuxt-link>
      )
    } else {
      return (
        <div class="product-page-info__bakset-button" onClick={this.addToBasket}>
          <div class="product-page-info__bakset-button-text">
            В корзину
          </div>
        </div>
      )
    }
  }

  renderWaitingListButton () {
    return (
      <SwitchElement {...{
        props: {
          value: this.isWaitingList,
          name: 'waiting',
          label: 'Сообщим о поступлении',
          modifiers: [...['waiting'], ...this.isWaitingListModifier]
        },
        on: {
          change: async (v: boolean) => {
            await this.addToWaitingList(v)
          }
        },
        scopedSlots: {
          textPayload: () => 'Сообщим о поступлении'
        }
      }} />
    )
  }

  renderBasketWrapper () {
    if (this.isAvailable) {
      return (
        <div class="product-page-info__basket-wrapper">
          <div class="product-page-info__price-wrapper">
            <div class="product-page-info__price-value" itemprop="offers" itemscope itemtype="https://schema.org/Offer">
              <span itemprop="price" content={s(this.$store).productPage.price}>{s(this.$store).productPage.price}</span>
              <span itemprop="priceCurrency" content="RUB"> ₽</span>
              <meta itemprop="availability" href="https://schema.org/InStock" content="InStock" />
            </div>
            {this.isDiscount &&
              <div class="product-page-info__price-discount">
                {s(this.$store).productPage.basePrice} ₽
              </div>
            }
          </div>
          {this.renderBasketButton()}
          {this.isBasket &&
            <div class="product-page-info__bakset-selector">
              <BasketNumber {...{
                props: {
                  id: s(this.$store).productPage.id,
                  isLarge: true
                }
              }} />
            </div>
          }
        </div>
      )
    } else {
      return (
        <div class="product-page-info__basket-wrapper">
          <div class="product-page-info__basket-text-not-available">
            Товара нет в наличии
          </div>
          {this.renderWaitingListButton()}
        </div>
      )
    }
  }

  renderProperty (name: string, value: string) {
    return (
      <div class="product-page-info__property-item">
        <div class="product-page-info__property-item-name">
          {name}
        </div>
        <div class="product-page-info__property-item-dots"></div>
        <div class="product-page-info__property-item-value">
          {value}
        </div>
      </div>
    )
  }

  renderPropertyWithTooltip (name: string, value: string, tooltip?: string) {
    return (
      <div class="product-page-info__property-item">
        <div class="product-page-info__property-item-name">
          {name}
        </div>
        <div class="product-page-info__property-item-dots"></div>
        <div class="product-page-info__property-item-value" v-tooltip={tooltip}>
          {value}
        </div>
      </div>
    )
  }

  renderPropertyMnn (name: string, value: string) {
    const listMnn = value.split('+')
    return (
      <div class="product-page-info__property-item">
        <div class="product-page-info__property-item-name">
          {name}
        </div>
        <div class="product-page-info__property-item-dots"></div>
        <div class="product-page-info__property-item-value-mnn-list">
          {listMnn.map((e: string, index: number, array: string[]) => {
            return (<div class="product-page-info__property-item-value-mnn"
              onclick={() => this.$router.push({
                path: '/apteki/search/',
                query: {
                  q: e,
                  'filter[MNN][]': e
                }
              })}>
              {e}
              {index === array.length - 1 ? '' : <span class="product-page-info__property-item-value-mnn-separator">+</span>}
            </div>)
          })}
        </div>
      </div>
    )
  }

  renderManufacturer () {
    if (s(this.$store).productPage.manufacturer) {
      return (
        <div class="product-page-info__property-item" itemprop="brand" itemscope itemtype="https://schema.org/Brand">
          <div class="product-page-info__property-item-name">
            Производитель, страна
          </div>
          <div class="product-page-info__property-item-dots"></div>
          <div class="product-page-info__property-item-value" itemprop="name">
            {s(this.$store).productPage.manufacturer}
            {s(this.$store).productPage.country ? ', ' + s(this.$store).productPage.country : ''}
          </div>
        </div>
      )
    }
  }

  renderPrescriptionText () {
    const byPrescription = s(this.$store).productPage.byPrescription

    if (byPrescription) {
      return (
        <div class="product-page-info__prescription-wrapper">
          <div class="product-page-info__prescription-logo">
            <ErrorSvg />
          </div>
          <div class="product-page-info__prescription-text">
            {byPrescription
              ? 'Рецептурные препараты доставляются до пункта выдачи.'
              : 'Ветеринарные препараты доставляются до пункта выдачи.'
            }
          </div>
        </div>
      )
    }
  }

  renderRating () {
    const { value: rating, reviews: { total: reviewsCount } } = s(this.$store).productPage.rating

    return (
      <RatingStars {...{
        props: { rating, reviewsCount }
      }} />
    )
  }

  render () {
    const { canReview } = s(this.$store).productPage

    return (
      <div class={{
        'product-page-info': true,
        'not-available': !this.isAvailable
      }}>
        <div class="product-page-info__tags-wrapper">
          <div class="product-page-info__tags">
            {s(this.$store).productPage.byPrescription &&
            <div class="product-page-info__tags-prescription">
              По рецепту
            </div>
            }
            {s(this.$store).productPage.isVeterinary &&
            <div class="product-page-info__tags-prescription">
              Вет препарат
            </div>
            }

            {s(this.$store).productPage.promoAction &&
            <div class="product-page-info__tags-item">
              <DiscountSvg />
            </div>
            }
            {s(this.$store).productPage.isProductHit &&
            <div class="product-page-info__tags-item">
              <HotSvg />
            </div>
            }
            {s(this.$store).productPage.isProductNew &&
            <div class="product-page-info__tags-item">
              <NewSvg />
            </div>
            }
            {s(this.$store).productPage.isProductDay &&
            <div class="product-page-info__tags-item">
              <ProductDaySvg />
            </div>
            }
          </div>

          <div {...{
            class: {
              'product-card__to-user-list': true,
              'product-card__to-user-list_selected': this.inUList,
              'product-card__to-user-list-productPage': true
            },
            on: {
              click: (event: MouseEvent) => {
                event.preventDefault()
                this.renderUserLists = true
              }
            },
            directives: [{
              name: 'VueClickOutside',
              value: () => this.renderUserLists = false
            }]
          }}>
            <List />
            {this.renderUserLists &&
            <UserLists {...{
              props: {
                productId: s(this.$store).productPage.id,
                product: s(this.$store).productPage,
                route: this.$router
              }
            }}/>}
            <div class="product-card__to-user-list-productPage-text">
              {this.inUList ? 'В списке' : 'В список'}
            </div>
          </div>

          <div class={{
            'product-page-info__favorite': true,
            'product-page-info__favorite_selected': this.isFavorite
          }} onClick={(event: MouseEvent) => {
            event.stopPropagation()
            s(this.$store).wishlist.changeProduct(s(this.$store).productPage.id)
          }}>
            <div class="product-page-info__favorite-icon">
              <HeartSvg />
            </div>
            <div class="product-page-info__favorite-text">
              {this.isFavorite ? 'В избранном' : 'В избранное'}
            </div>
          </div>
        </div>
        <div class="product-page-info__title-wrapper">
          {
            s(this.$store).productPage.seoName ? <div class="product-page-info__title">{s(this.$store).productPage.title}</div>
              : <h1 class="product-page-info__title" itemprop="name">{s(this.$store).productPage.title}</h1>
          }
          <div class="product-page-info__trait">
            {s(this.$store).productPage.trait}
          </div>
          <div class="product-page-info__rating">
            { canReview && this.renderRating() }
          </div>
        </div>
        {!!s(this.$store).productPage.images.length &&
          <div class="product-page-info__image">

            <agile options={this.sliderOptions}>
              {s(this.$store).productPage.images.map(img => (
                <ImageElement {...{
                  props: {
                    img,
                    isMicrodata: true,
                    alt: s(this.$store).productPage.title
                  }
                }} />))}
            </agile>
          </div>
        }
        {this.renderBasketWrapper()}
        {this.renderPrescriptionText()}
        {this.renderAnalogs()}
        <div class="product-page-info__property-list">
          {this.expirationDate && this.renderPropertyWithTooltip('Срок годности', this.expirationDate, this.expirationTooltip)}
          {this.isMnn && this.renderPropertyMnn('Действующее вещество (MNN)', s(this.$store).productPage.mnn)}
          {s(this.$store).productPage.releaseForm && this.renderProperty('Форма выпуска', s(this.$store).productPage.releaseForm)}
          {s(this.$store).productPage.primaryPackaging && this.renderProperty('Первичная упаковка', s(this.$store).productPage.primaryPackaging)}
          {this.renderManufacturer()}
        </div>
      </div>
    )
  }
}
